import { render, staticRenderFns } from "./SHNavMenu.vue?vue&type=template&id=4fc621e8&"
import script from "./SHNavMenu.vue?vue&type=script&lang=ts&"
export * from "./SHNavMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports